<template>
  <div class="restaurant-nav d-inline-flex pb-3 gap-2">
    <router-link :to="{name: 'RestMenu'}" class="btn btn-outline-dark px-3">{{ $t('navRest.menu') }}</router-link>
    <router-link :to="{name: 'RestCategories'}" class="btn btn-outline-dark px-3">{{ $t('navRest.categories') }}</router-link>
    <router-link :to="{name: 'RestModifiers'}" class="btn btn-outline-dark px-3">{{ $t('navRest.modifiers') }}</router-link>
    <router-link :to="{name: 'RestOrders'}" class="btn btn-outline-dark px-3">{{ $t('navRest.orders') }}</router-link>
    <router-link :to="{name: 'ModulesLayout'}" class="btn btn-outline-dark px-3">{{ $t('navRest.modules') }}</router-link>
    <router-link :to="{name: 'RestSettings'}" class="btn btn-outline-dark px-3">{{ $t('navRest.settings') }}</router-link>
    <router-link :to="{name: 'RestDeploy'}" class="btn btn-outline-dark px-3">{{ $t('navRest.deploy') }}</router-link>
  </div>
</template>

<script>
export default {
  name: "NavRest"
}
</script>

<style scoped>

</style>